import ApiService from "./ApiService";
//import utilityService from "./utilityService";

const getAll = async () => {
  try {
    const url = "/GetAllProducts";
    const response = await ApiService.get(url);
    if (response && response.data) return response.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return [];
};

// const getOne = async (id) => {
//   try {
//     const url = `/GetProductDetails?Id=${id}`;
//     const response = await ApiService.get(url);
//     if (response && response.data) return response.data;
//   } catch (err) {
//     console.log("ApiError", err.message);
//   }
//   return [];
// };

// const update = async (data) => {
//   const url = "/UpdateAdditionalLocation?" + utilityService.queryString(data);
//   try {
//     const result = await ApiService.post(url, data, {
//       "Content-Type": "application/json",
//     });
//     if (result.status === 200)
//       return {
//         success: true,
//         message: result.data,
//       };
//   } catch (err) {
//     console.log("ApiError", err.message);
//   }
//   return {
//     success: false,
//     message: "Failed to update deco method",
//   };
// };

// const add = async (data) => {
//   const url = "/AddAdditionalLocation?" + utilityService.queryString(data);

//   try {
//     const result = await ApiService.post(url, data, {
//       "Content-Type": "application/json",
//     });
//     if (result.status === 200)
//       return {
//         success: true,
//         message: result.data,
//       };
//   } catch (err) {
//     console.log("ApiError", err.message);
//   }
//   return {
//     success: false,
//     message: "Failed to add new additional location",
//   };
// };

// const remove = async (id) => {
//   const url = "/DeleteAdditionalLocation?Id=" + id;

//   try {
//     const result = await ApiService.post(url);
//     if (result.status === 200)
//       return {
//         success: true,
//         message: result.data,
//       };
//   } catch (err) {
//     console.log("ApiError", err.message);
//   }
//   return {
//     success: false,
//     message: "Failed to remove additional location",
//   };
// };

export default {
  getAll,
//   getOne,
//   add,
//   update,
//   remove,
};
